/** Formatters for values that come from the API and end up on screen. */

/**
 * Format an API timestamp without ever throwing.
 *
 * `Intl.DateTimeFormat.format(new Date(x))` raises `RangeError` when `x` does not parse,
 * and a raise inside render unmounts the whole screen: there is no error boundary above
 * the pages. A malformed `received_at` must cost the cell, not the page, so the raw
 * string is shown instead.
 */
export function formatDate(formatter: Intl.DateTimeFormat, value: string): string {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return value;
  }
  return formatter.format(date);
}

/** Attachment size for a human: bytes, whole KB, or MB with one decimal. */
export function formatBytes(size: number): string {
  if (size < 1024) return `${size} B`;
  if (size < 1024 * 1024) return `${(size / 1024).toFixed(0)} KB`;
  return `${(size / (1024 * 1024)).toFixed(1)} MB`;
}
